import { Link } from 'gatsby'
import React from 'react'

const navItems = [
  {
    name: 'Home',
    url: '/',
  },
  {
    name: 'Shop',
    url: 'https://shop.bluerondogames.com/',
    external: true,
  },
  {
    name: 'Joker Crabs',
    url: '/crabs/imitation_crab',
  },
  {
    name: 'Shrimpocalypse',
    url: '/shrimpocalypse',
  },
  {
    name: 'Blue Rondo Games',
    url: 'https://bluerondogames.com/',
    external: true,
  },
]
const shrimpNavItems = [
  {
    name: 'Home',
    url: '/',
  },
  {
    name: 'Shop',
    url: 'https://shop.bluerondogames.com/',
    external: true,
  },
  {
    name: 'Joker Crabs',
    url: '/crabs/pea_crab'
  },
  {
    name: 'Shrimpocalypse',
    url: '/shrimpocalypse',
  },
  {
    name: 'Blue Rondo Games',
    url: 'https://bluerondogames.com/',
    external: true,
  },
]

const NavbarMenu = ({ navMenuOpen, theme }) => (
  <div className={`
    absolute
    left-0
    overflow-y-hidden
    top-20
    w-full
    z-10
    transition-height
    duration-300
    ${!navMenuOpen ? 'h-0' : 'h-100'
      /* the h-80 above must correspond to the total
         height of the nav menu, based on the number
         of items. e.g. for 4 items:
         4 * 5rem = 20rem = "h-80" */
    }
      max-h-[calc(100vh-5rem)]
  `}>
    <ul
      aria-hidden={!navMenuOpen}
      className={`
        max-h-[calc(100vh-5rem)]
        bg-rondoblue
        duration-300
        ease-in-out
        overflow-y-scroll
        transition-transform
        ${!navMenuOpen ? '-translate-y-full' : ''}
        w-full
        z-20
      `}
      id="nav-menu"
    >
      {(theme === 'shrimpocalypse' ? shrimpNavItems : navItems).map(item => (
        <li className='
          hover:bg-rondoblue-light
          transition-colors
        '>
          {item.external ? 
            <a
              aria-label={item.name}
              href={item.url}
              rel="noreferrer"
              target='_blank'
            >
              <h2 className='
                py-6
                text-white
                z-20
              '>
                {item.name}
              </h2>
            </a>
          :
            <Link
              aria-label={item.name}
              to={item.url}
            >
              <h2 className='
                py-6
                text-white
                z-20
              '>
                {item.name}
              </h2>
            </Link>
          }
        </li>
      ))}
    </ul>
  </div>
)

export default NavbarMenu
